<template>
  <div v-if="editable">
    <p
      v-for="(item, index) in localItems"
      class="field is-grouped"
      :key="index">
      <input
        v-model="localItems[index]"
        class="input is-small"
      >
      <button
        class="button is-small is-danger"
        @click="removeItem(index)"
      >
        <span class="icon is-small">
          <i class="fas fa-trash" />
        </span>
      </button>
    </p>

    <p>
      <button
        class="button is-small is-primary"
        @click="addItem"
      >
        Add an item
      </button>
    </p>
  </div>

  <div v-else>
    <ul class="tw-list-disc tw-list-inside tw-text-gray-600 tw-mb-6">
      <li
        v-for="(item, index) in localItems"
        :key="index"
      >
        {{ item }}
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'EditableList',
  props: {
    items: {
      type: Array,
      required: true,
    },
    editable: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      localItems: [],
    };
  },
  watch: {
    items: {
      immediate: true,
      handler(newItems) {
        this.localItems = JSON.parse(JSON.stringify(newItems));
      },
    },
    editable(newValue, oldValue) {
      // When switching from edit mode to view mode, emit the update
      if (oldValue && !newValue) {
        this.$emit('update', this.localItems);
      }
    }
  },
  methods: {
    addItem() {
      this.localItems.push("");
    },
    removeItem(index) {
      this.localItems.splice(index, 1);
    },
  },
};
</script>
